export const allWeapons = [
    {
        name: "ACR",
        type: "Assault Rifle",
        rateOfFire: 650,
        adsTime: 320,
        sprintToFire: 320,
        sprintSpeed: 0.9,
        adsMoveSpeed: 0.9,
        magSize: 30,
        reloadTime: 2300,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 18,
        hipfire: 5,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 33, damage: 21}, {range: 45, damage: 19}, {range: 300, damage: 17}],
        multipliers: {head: 1.4},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4",
            "z1", "z2", "z3", "z4",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s5", "s6"
        ]
    },
    {
        name: "M4A1",
        type: "Assault Rifle",
        rateOfFire: 725,
        adsTime: 267,
        sprintToFire: 267,
        sprintSpeed: 0.9,
        adsMoveSpeed: 0.9,
        magSize: 30,
        reloadTime: 2233,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 18,
        hipfire: 5,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 38, damage: 17}, {range: 50, damage: 16}, {range: 300, damage: 14}],
        multipliers: {head: 1.4},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4",
            "z1", "z2", "z3", "z4",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s5"
        ]
    },
    {
        name: "AK-47",
        type: "Assault Rifle",
        rateOfFire: 600,
        adsTime: 300,
        sprintToFire: 300,
        sprintSpeed: 0.9,
        adsMoveSpeed: 0.9,
        magSize: 30,
        reloadTime: 2133,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 18,
        hipfire: 5,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 29, damage: 22}, {range: 43, damage: 20}, {range: 300, damage: 18}],
        multipliers: {head: 1.7},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4",
            "z1", "z2", "z3", "z4",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s5", "s6"
        ]
    },
    {
        name: "M16A4",
        type: "Assault Rifle",
        rateOfFire: 270,
        adsTime: 300,
        sprintToFire: 300,
        sprintSpeed: 0.9,
        adsMoveSpeed: 0.9,
        magSize: 30,
        reloadTime: 2167,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 18,
        hipfire: 5,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 34, damage: 24}, {range: 45, damage: 21}, {range: 300, damage: 17}],
        multipliers: {head: 1.55},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4",
            "z1", "z2", "z3", "z4",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s5"
        ]
    },
    {
        name: "MDR",
        type: "Assault Rifle",
        rateOfFire: 765,
        adsTime: 300,
        sprintToFire: 250,
        sprintSpeed: 0.9,
        adsMoveSpeed: 0.9,
        magSize: 30,
        reloadTime: 2100,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 18,
        hipfire: 4,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 23, damage: 17}, {range: 35, damage: 16}, {range: 300, damage: 14}],
        multipliers: {head: 1.4},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4",
            "z1", "z2", "z3", "z4",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4",
        ]
    },
    {
        name: "MP5A2",
        type: "SMG",
        rateOfFire: 800,
        adsTime: 170,
        sprintToFire: 184,
        sprintSpeed: 1,
        adsMoveSpeed: 1,
        magSize: 30,
        reloadTime: 2400,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 43,
        hipfire: 4,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 16, damage: 18}, {range: 25, damage: 13}, {range: 100, damage: 10}],
        multipliers: {head: 1.3},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3",
            "z1", "z2", "z3", "z19",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s5", "s6"
        ]
    },
    {
        name: "MP7",
        type: "SMG",
        rateOfFire: 900,
        adsTime: 180,
        sprintToFire: 184,
        sprintSpeed: 1,
        adsMoveSpeed: 1,
        magSize: 35,
        reloadTime: 1933,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 43,
        hipfire: 4,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 17, damage: 19}, {range: 22, damage: 11}, {range: 100, damage: 8}],
        multipliers: {head: 1.2},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3",
            "z1", "z2", "z3", "z19",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s5", "s6"
        ]
    },
    {
        name: "P90",
        type: "SMG",
        rateOfFire: 830,
        adsTime: 170,
        sprintToFire: 170,
        sprintSpeed: 1,
        adsMoveSpeed: 1,
        magSize: 50,
        reloadTime: 2833,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 40,
        hipfire: 4,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 18, damage: 18}, {range: 24, damage: 13}, {range: 100, damage: 10}],
        multipliers: {head: 1.3},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f2", "f4", "f6",
            "o1", "o2", "o3",
            "z1", "z2", "z3", "z19",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s5", "s6"
        ]
    },
    {
        name: "Vector .45",
        type: "SMG",
        rateOfFire: 1000,
        adsTime: 180,
        sprintToFire: 180,
        sprintSpeed: 1,
        adsMoveSpeed: 1,
        magSize: 25,
        reloadTime: 2140,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 43,
        hipfire: 4,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 13, damage: 19}, {range: 19, damage: 11}, {range: 100, damage: 8}],
        multipliers: {head: 1.2},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3",
            "z1", "z2", "z3", "z19",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s5", "s6"
        ]
    },
    {
        name: "M249",
        type: "LMG",
        rateOfFire: 600,
        adsTime: 425,
        sprintToFire: 425,
        sprintSpeed: 0.9,
        adsMoveSpeed: 0.9,
        magSize: 100,
        reloadTime: 9000,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 34,
        hipfire: 6,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 31, damage: 23}, {range: 42, damage: 20}, {range: 300, damage: 18}],
        multipliers: {head: 1.4},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4", "o6",
            "z18", "z2", "z9", "z16",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s6"
        ]
    },
    {
        name: "RPK-74",
        type: "LMG",
        rateOfFire: 525,
        adsTime: 475,
        sprintToFire: 475,
        sprintSpeed: 0.9,
        adsMoveSpeed: 0.9,
        magSize: 45,
        reloadTime: 3000,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 34,
        hipfire: 6,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 36, damage: 23}, {range: 48, damage: 21}, {range: 300, damage: 20}],
        multipliers: {head: 1.4},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4", "o6",
            "z18", "z2", "z10", "z16",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s6"
        ]
    },
    {
        name: "M60",
        type: "LMG",
        rateOfFire: 500,
        adsTime: 400,
        sprintToFire: 450,
        sprintSpeed: 0.9,
        adsMoveSpeed: 0.9,
        magSize: 100,
        reloadTime: 9400,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 34,
        hipfire: 6,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 34, damage: 25}, {range: 45, damage: 23}, {range: 300, damage: 20}],
        multipliers: {head: 1.4},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4", "o6",
            "z18", "z2", "z9", "z16",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s6"
        ]
    },
    {
        name: "M870",
        type: "Shotgun",
        rateOfFire: 80,
        adsTime: 200,
        sprintToFire: 250,
        sprintSpeed: 1,
        adsMoveSpeed: 1,
        magSize: 5,
        reloadTime: 900,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 58,
        hipfire: 4,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 9, damage: 14}, {range: 13, damage: 8}, {range: 35, damage: 6}],
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3",
            "z18",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4",
        ]
    },
    {
        name: "AA-12",
        type: "Shotgun",
        rateOfFire: 300,
        adsTime: 200,
        sprintToFire: 200,
        sprintSpeed: 1,
        adsMoveSpeed: 1,
        magSize: 8,
        reloadTime: 2467,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 58,
        hipfire: 5,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 7, damage: 8}, {range: 10, damage: 5}, {range: 30, damage: 4}],
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3",
            "z18",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3",
        ]
    },
    {
        name: "Double-Barreled",
        type: "Shotgun",
        rateOfFire: 200,
        adsTime: 200,
        sprintToFire: 250,
        sprintSpeed: 1.1,
        adsMoveSpeed: 1.1,
        magSize: 2,
        reloadTime: 1034,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 58,
        hipfire: 4,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 10, damage: 15}, {range: 14, damage: 10}, {range: 40, damage: 7}],
        attachments: [
            "b8",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4",
        ]
    },
    {
        name: "MK 20 SSR",
        type: "Marksman Rifle",
        rateOfFire: 200,
        adsTime: 350,
        sprintToFire: 350,
        sprintSpeed: 1.1,
        adsMoveSpeed: 1.1,
        magSize: 10,
        reloadTime: 2000,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 71,
        hipfire: 6,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 40, damage: 49}, {range: 60, damage: 43}, {range: 300, damage: 41}],
        multipliers: {head: 1.8},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4", "o5", "o6", "o7",
            "z17", "z2", "z5", "z14",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s6",
        ]
    },
    {
        name: "SVD",
        type: "Marksman Rifle",
        rateOfFire: 185,
        adsTime: 350,
        sprintToFire: 350,
        sprintSpeed: 0.9,
        adsMoveSpeed: 0.9,
        magSize: 10,
        reloadTime: 2967,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 71,
        hipfire: 6,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 45, damage: 49}, {range: 70, damage: 47}, {range: 300, damage: 45}],
        multipliers: {head: 2},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4", "o5", "o6", "o7",
            "z17", "z2", "z5", "z14",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s4", "s6",
        ]
    },
    {
        name: "M44",
        type: "Sniper Rifle",
        rateOfFire: 48,
        adsTime: 350,
        sprintToFire: 350,
        sprintSpeed: 1.1,
        adsMoveSpeed: 1.1,
        magSize: 5,
        reloadTime: 833,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 1800,
        hipfire: 14,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 27, damage: 70}, {range: 45, damage: 70}, {range: 300, damage: 70}],
        multipliers: {
            head: 2,
            chest: 1.8
        },
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o1", "o2", "o3", "o4", "o5", "o6", "o7",
            "z1", "z12", "z11", "z15",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s7",
        ]
    },
    {
        name: "TAC-50",
        type: "Sniper Rifle",
        rateOfFire: 38,
        adsTime: 600,
        sprintToFire: 600,
        sprintSpeed: 1.1,
        adsMoveSpeed: 1.1,
        magSize: 5,
        reloadTime: 3067,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 2400,
        hipfire: 14,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 27, damage: 90}, {range: 45, damage: 90}, {range: 300, damage: 90}],
        multipliers: {
            head: 1.8,
            chest: 1.6,
            body: 1.6
        },
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "b1", "b2", "b3", "b4", "b5", "b6", "b7",
            "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9",
            "o4", "o5", "o6", "o7",
            "z1", "z12", "z11", "z15",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s1", "s2", "s3", "s7",
        ]
    },
    {
        name: "M1911",
        type: "Pistol",
        rateOfFire: 350,
        adsTime: 150,
        sprintToFire: 150,
        sprintSpeed: 1,
        adsMoveSpeed: 1,
        magSize: 7,
        reloadTime: 1633,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 12,
        hipfire: 5,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 10, damage: 30}, {range: 20, damage: 24}, {range: 50, damage: 18}],
        multipliers: {head: 1.6},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "o1", "o8",
            "z18", "z13", "z6", "z15",
            "g1", "g2", "g3", "g4", "g6", "g6",

        ]
    },
    {
        name: "686 Magnum",
        type: "Pistol",
        rateOfFire: 150,
        adsTime: 150,
        sprintToFire: 150,
        sprintSpeed: 1,
        adsMoveSpeed: 1,
        magSize: 6,
        reloadTime: 3033,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 42,
        hipfire: 5,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 10, damage: 48}, {range: 30, damage: 44}, {range: 60, damage: 34}],
        multipliers: {head: 2},
        attachments: [
            "m2", "m3", "m4", "m5",
            "o1", "o8",
            "g1", "g2", "g3", "g4", "g6", "g6",
        ]
    },
    {
        name: "93R",
        type: "Pistol",
        rateOfFire: 475,
        adsTime: 150,
        sprintToFire: 150,
        sprintSpeed: 0.9,
        adsMoveSpeed: 0.9,
        magSize: 15,
        reloadTime: 1667,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 12,
        hipfire: 6,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 10, damage: 17}, {range: 20, damage: 15}, {range: 50, damage: 13}],
        multipliers: {head: 1.8},
        attachments: [
            "m2", "m3", "m4", "m5",
            "o1", "o8",
            "z18", "z13", "z7", "z15",
            "g1", "g2", "g3", "g4", "g6", "g6",
            "s8"
        ]
    },
    {
        name: "M9",
        type: "Pistol",
        rateOfFire: 400,
        adsTime: 150,
        sprintToFire: 150,
        sprintSpeed: 1.1,
        adsMoveSpeed: 1.1,
        magSize: 15,
        reloadTime: 1533,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 12,
        hipfire: 5,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 10, damage: 24}, {range: 20, damage: 20}, {range: 50, damage: 15}],
        multipliers: {head: 1.6},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "o1", "o8",
            "z18", "z13", "z8", "z15",
            "g1", "g2", "g3", "g4", "g6", "g6",

        ]
    },
    {
        name: "D50",
        type: "Pistol",
        rateOfFire: 200,
        adsTime: 150,
        sprintToFire: 150,
        sprintSpeed: 1.1,
        adsMoveSpeed: 1.1,
        magSize: 7,
        reloadTime: 1600,
        recoil: {vertical: 50, horizontal: 50, recovery: 50},
        aimStability: 12,
        hipfire: 5,
        minimapVisibility: 1,
        penetration: 1,
        damageRanges: [{range: 10, damage: 45}, {range: 30, damage: 33}, {range: 50, damage: 25}],
        multipliers: {head: 2},
        attachments: [
            "m1", "m2", "m3", "m4", "m5", "m6",
            "o1", "o8",
            "z18", "z13", "z8", "z15",
            "g1", "g2", "g3", "g4", "g6", "g6",

        ]
    }
]

export const allAttachments =
    {
        Muzzle: [
            {
                id: "m1",
                name: "Lightweight Suppressor",
                effects: {
                    minimapVisibilityRange: 24,
                    minimapVisibility: -0.5
                }
            },
            {
                id: "m2",
                name: "Muzzle Booster",
                effects: {
                    rateOfFire: 0.025,
                    recoil: {vertical: 0.1, horizontal: 0.1}
                }
            },
            {
                id: "m3",
                name: "Barrel Extender",
                effects: {
                    dmgRanges: [
                        {
                            range: 1,
                            modifier: 0.1
                        },
                        {
                            range: 2,
                            modifier: 0.1
                        }
                    ],
                    sprintToFire: 0.1,
                    recoil: {recovery: -0.1}
                }
            },
            {
                id: "m4",
                name: "Muzzle Break",
                effects: {
                    dmgRanges: [
                        {
                            range: 1,
                            modifier: -0.05
                        },
                        {
                            range: 2,
                            modifier: -0.05
                        }
                    ],
                    recoil: {horizontal: -0.07},

                }
            },
            {
                id: "m5",
                name: "Compensator",
                effects: {
                    recoil: {vertical: -0.07},
                    adsTime: 0.1,
                    aimStability: -0.05
                }
            },
            {
                id: "m6",
                name: "Suppressor",
                effects: {
                    dmgRanges: [
                        {
                            range: 1,
                            modifier: -0.1
                        },
                        {
                            range: 2,
                            modifier: -0.1
                        }
                    ],
                    minimapVisibilityRange: 0,
                    minimapVisibility: -1
                }
            }
        ],
        Barrel: [
            {
                id: "b1",
                name: "Recon",
                effects: {
                    minimapVisibilityRange: 24,
                    minimapVisibility: -0.5,
                    adsTime: -0.05,
                    sprintSpeed: -0.025,
                    adsMoveSpeed: -0.025
                }
            },
            {
                id: "b2",
                name: "Stabilizing",
                effects: {
                    recoil: {vertical: -0.025, horizontal: -0.025},
                    sprintToFire: 0.05,
                    adsMoveSpeed: -0.05
                }
            },
            {
                id: "b3",
                name: "Rapid Fire",
                effects: {
                    rateOfFire: 0.05,
                    recoil: {vertical: 0.2, horizontal: 0.2},
                }
            },
            {
                id: "b4",
                name: "Heavy",
                effects: {
                    damage: 0.05,
                    rateOfFire: -0.1
                }
            },
            {
                id: "b5",
                name: "Stealth",
                effects: {
                    dmgRanges: [
                        {
                            range: 1,
                            modifier: 0.1
                        },
                        {
                            range: 2,
                            modifier: 0.1
                        }
                    ],
                    minimapVisibilityRange: 0,
                    minimapVisibility: -1,
                    rateOfFire: -0.025,
                    sprintSpeed: -0.05,
                    adsMoveSpeed: -0.05,
                }
            },
            {
                id: "b6",
                name: "Lightweight",
                effects: {
                    dmgRanges: [
                        {
                            range: 1,
                            modifier: -0.1
                        },
                        {
                            range: 2,
                            modifier: -0.1
                        }
                    ],
                    adsTime: -0.15,
                    sprintSpeed: 0.05,
                    adsMoveSpeed: 0.05,

                }
            },
            {
                id: "b7",
                name: "Chrome Lined",
                effects: {
                    dmgRanges: [
                        {
                            range: 1,
                            modifier: 0.2
                        },
                        {
                            range: 2,
                            modifier: 0.2
                        }
                    ],
                    sprintSpeed: -0.05,
                    adsMoveSpeed: -0.05,
                    adsTime: 0.15
                }
            },
            {
                id: "b8",
                name: "Choke",
                effects: {
                    dmgRanges: [
                        {
                            range: 1,
                            modifier: 0.15
                        },
                        {
                            range: 2,
                            modifier: 0.15
                        }
                    ],
                    hipfire: 0.05,
                    sprintToFire: 0.15
                }
            },
            {}
        ],
        Front_Rail: [
            {
                id: "f1",
                name: "Angled Grip",
                effects: {
                    aimStability: 0.15,
                    recoil: {horizontal: -0.05},
                    sprintSpeed: -0.05,
                    adsMoveSpeed: -0.05
                }
            },
            {
                id: "f2",
                name: "Superlight Grip",
                effects: {
                    adsTime: -0.1,
                    recoil: {recovery: -0.1},
                    sprintSpeed: 0.025,
                    adsMoveSpeed: 0.025
                }
            },
            {
                id: "f3",
                name: "Vertical Grip",
                effects: {
                    adsTime: 0.05,
                    recoil: {vertical: -0.1},
                    adsMoveSpeed: -0.05
                }
            },
            {
                id: "f4",
                name: "Tactical Grip",
                effects: {
                    adsTime: -0.05,
                    recoil: {recovery: 0.35},
                    adsMoveSpeed: -0.05
                }
            },
            {
                id: "f5",
                name: "Small Vertical Grip",
                effects: {
                    adsTime: -0.05,
                    adsMoveSpeed: 0.10,
                    hipfire: 0.15
                }
            },
            {
                id: "f6",
                name: "PEQ-15 Laser",
                effects: {
                    hipfire: -0.4
                }
            },
            {
                id: "f7",
                name: "Handstop",
                effects: {
                    aimStability: 0.15,
                    recoil: {vertical: -0.05},
                    sprintSpeed: -0.05,
                    adsMoveSpeed: -0.05
                }
            },
            {
                id: "f8",
                name: "Leather-Wrapped Foregrip",
                effects: {
                    adsMoveSpeed: 0.15,
                    aimStability: 0.1,
                    sprintToFire: 0.05,
                    adsTime: 0.1,
                }
            },
            {
                id: "f9",
                name: "Pistol Grip",
                effects: {
                    sprintToFire: -0.1,
                    hipfire: -0.2,
                    recoil: {horizontal: 0.05},
                }
            },
        ],
        Optic: [
            {
                id: "o1",
                name: "Reflex Sight",
                effects: {}
            },
            {
                id: "o2",
                name: "Holographic Sight",
                effects: {}
            },
            {
                id: "o3",
                name: "3x Scope",
                effects: {
                    adsTime: 0.1,
                    adsFlinch: 0.1
                }
            },
            {
                id: "o4",
                name: "ACOG Scope (4x)",
                effects: {
                    adsTime: 0.1,
                    adsFlinch: 0.1
                }
            },
            {
                id: "o5",
                name: "Variable Zoom Scope (4x-8x)",
                effects: {
                    adsTime: 0.15,
                    adsFlinch: 0.1
                }
            },
            {
                id: "o6",
                name: "CQBSS Scope (8x)",
                effects: {
                    adsTime: 0.20,
                    adsFlinch: 0.25
                }
            },
            {
                id: "o7",
                name: "Sniper Scope (12x)",
                effects: {
                    adsTime: 0.20,
                    adsFlinch: 0.25
                }
            },
            {
                id: "o8",
                name: "Red Dot Sight",
                effects: {}
            },
        ],
        Magazine: [
            {
                id: "z1",
                name: "Quick Mag",
                effects: {
                    magSize: 5,
                    reloadTime: -0.15,
                }
            },
            {
                id: "z2",
                name: "Lightweight Mag",
                effects: {
                    sprintSpeed: -0.025,
                    adsMoveSpeed: -0.025,
                    reloadTime: -0.1,
                }
            },
            {
                id: "z3",
                name: "Extended Mag",
                effects: {
                    magSize: 15,
                    reloadTime: 0.15,
                    sprintSpeed: -0.05,
                    adsMoveSpeed: -0.05,
                }
            },
            {
                id: "z4",
                name: "Fast Mag",
                effects: {
                    magSize: 6,
                    reloadTime: -0.4,
                    adsTime: 0.1,
                    adsMoveSpeed: -0.05,
                    adsFlinch: 0.1
                }
            },
            {
                id: "z5",
                name: "Extended Mag [MK20]",
                effects: {
                    magSize: 10,
                    reloadTime: 0.15,
                }
            },
            {
                id: "z6",
                name: "Extended Mag [M1911]",
                effects: {
                    magSize: 8,
                    reloadTime: 0.15,
                    sprintSpeed: -0.05,
                    adsMoveSpeed: -0.05,
                }
            },
            {
                id: "z7",
                name: "Extended Mag [93R]",
                effects: {
                    magSize: 5,
                    reloadTime: 0.5,
                    sprintSpeed: -0.05,
                    adsMoveSpeed: -0.05,
                }
            },
            {
                id: "z8",
                name: "Extended Mag [M9,D50]",
                effects: {
                    magSize: 3,
                    reloadTime: 0.15,
                    sprintSpeed: -0.05,
                    adsMoveSpeed: -0.05,
                }
            },
            {
                id: "z9",
                name: "Extended Mag [M60,M249]",
                effects: {
                    magSize: 25,
                    reloadTime: 0.15,
                }
            },
            {
                id: "z10",
                name: "Extended Mag [RPK]",
                effects: {
                    magSize: 30,
                    reloadTime: 0.05,
                    adsTime: 0.1
                }
            },
            {
                id: "z11",
                name: "Extended Mag [Sniper]",
                effects: {
                    sprintSpeed: -0.05,
                    adsMoveSpeed: -0.05,
                    magSize: 2,
                    reloadTime: 0.05,
                }
            },
            {
                id: "z12",
                name: "Lightweight Mag [Sniper]",
                effects: {
                    sprintSpeed: -0.025,
                    adsMoveSpeed: -0.025,
                    magSize: -1,
                    reloadTime: -0.05,
                    extraMags: 4
                }
            },
            {
                id: "z13",
                name: "Lightweight Mag [Pistol]",
                effects: {
                    sprintSpeed: -0.025,
                    adsMoveSpeed: -0.025,
                    magSize: 4,
                    reloadTime: -0.10,
                    extraMags: 4
                }
            },
            {
                id: "z14",
                name: "Fast Mag [Marksman]",
                effects: {
                    magSize: 2,
                    reloadTime: -0.4,
                    adsTime: 0.1,
                    adsMoveSpeed: -0.025,
                    sprintSpeed: -0.025,
                    adsFlinch: 0.1
                }
            },
            {
                id: "z15",
                name: "Fast Mag [Pistol,Sniper]",
                effects: {
                    reloadTime: -0.4,
                    adsTime: 0.1,
                    adsFlinch: 0.1
                }
            },
            {
                id: "z16",
                name: "Fast Mag [LMG]",
                effects: {
                    reloadTime: -0.4,
                    adsTime: 0.1,
                    adsFlinch: 0.1,
                    adsMoveSpeed: -0.025,
                    sprintSpeed: -0.025,
                }
            },
            {
                id: "z17",
                name: "Quick Mag [Marksman]",
                effects: {
                    magSize: 2,
                    reloadTime: -0.15,
                }
            },
            {
                id: "z18",
                name: "Quick Mag [Pistol,Shotgun,LMG]",
                effects: {
                    reloadTime: -0.15,
                }
            },
            {
                id: "z19",
                name: "Fast Mag [SMG]",
                effects: {
                    magSize: 5,
                    reloadTime: -0.4,
                    adsTime: 0.1,
                    adsFlinch: 0.1
                }
            },
        ],
        Rear_Grip: [
            {
                id: "g1",
                name: "Grip Tape",
                effects: {
                    recoil: {vertical: -0.05, recovery: 0.15},
                    adsTime: 0.05,
                }
            },
            {
                id: "g2",
                name: "Fabric Grip",
                effects: {
                    adsTime: -0.1,
                    aimStability: 0.5,
                    recoil: {recovery: -0.1},
                }
            },
            {
                id: "g3",
                name: "Leather-Wrapped Grip",
                effects: {
                    adsMoveSpeed: 0.1,
                    sprintToFire: 0.5,
                }
            },
            {
                id: "g4",
                name: "Heavy Grip",
                effects: {
                    recoil: {horizontal: -0.025},
                    adsFlinch: -0.1
                }
            },
            {
                id: "g5",
                name: "Lightweight Grip",
                effects: {
                    recoil: {recovery: 0.25},
                    adsMoveSpeed: 0.025,
                    adsFlinch: 0.05
                }
            },
            {
                id: "g6",
                name: "Quick Draw Grip",
                effects: {
                    sprintToFire: -0.1,
                    adsTime: -0.1,
                    aimStability: -0.15
                }
            },
        ],
        Stock: [
            {
                id: "s1",
                name: "Padded Stock",
                effects: {
                    recoil: {recovery: 0.15},
                    aimStability: 0.1,
                    adsFlinch: -0.05
                }
            },
            {
                id: "s2",
                name: "Precision Stock",
                effects: {
                    recoil: {vertical: -0.05, horizontal: -0.05, recovery: -0.15},
                    adsTime: 0.1
                }
            },
            {
                id: "s3",
                name: "Reinforced Stock",
                effects: {
                    adsFlinch: -0.25,
                    aimStability: 0.1,
                    adsMoveSpeed: -0.15
                }
            },
            {
                id: "s4",
                name: "Lightweight Stock",
                effects: {
                    adsMoveSpeed: 0.2,
                    sprintSpeed: 0.025,
                    aimStability: -0.2,
                    adsTime: 0.1
                }
            },
            {
                id: "s5",
                name: "Removed Stock",
                effects: {
                    sprintToFire: -0.2,
                    adsMoveSpeed: 0.05,
                    sprintSpeed: 0.05,
                    adsFlinch: 0.1,
                    hipfire: 0.1
                }
            },
            {
                id: "s6",
                name: "Folded Stock",
                effects: {
                    adsMoveSpeed: 0.07,
                    sprintSpeed: 0.07,
                    hipfire: 0.1
                }
            },
            {
                id: "s7",
                name: "Lightweight Stock [Sniper]",
                effects: {
                    adsMoveSpeed: 0.2,
                    sprintSpeed: 0.025,
                    aimStability: -0.2,
                    adsTime: 0.1
                }
            },
            {
                id: "s8",
                name: "Lightweight Stock [93R]",
                effects: {
                    adsMoveSpeed: 0.2,
                    sprintSpeed: 0.025,
                    aimStability: -0.2,
                    adsTime: 0.1
                }
            },
        ]
    }